export const css = {
	root: 'KexbcyMT',
	text: '_25wBKVhF',
	valid: '_3TXlV68-',
	invalid: '_3pDuUhRf',
	' _key': 'certwise-theme/dojo/helper-text'
};

export default css;
